const line = "TRAVERTINO ROMANO   •   CAVA DI TIVOLI   •   TAGLIO CONTRO-FALDA   •   FINITURA A SPACCATO   •   MASSELLI MONOLITICI   •   SPEDIZIONI IN TUTTA ITALIA";

export default function EditorialMarquee() {
  return (
    <div className="editorial-marquee" data-testid="editorial-stone-marquee" aria-label="Specifiche StoneInLove">
      <div className="marquee-track"><span>{line}</span><span aria-hidden="true">{line}</span></div>
    </div>
  );
}
